<template>
  <div class="billManagement" style="padding-left:10px">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/billManagement' }">返回上一级</el-breadcrumb-item>
      <el-breadcrumb-item>
        {{title}}
      </el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 查询条件 -->
    <el-form :inline="true" :model="formData" :rules="rules" class="demo-form-inline" ref="formData">
      <el-form-item label="结算客户:" prop="customerName">
        <el-select v-model="formData.customerName" size="mini" placeholder="请选择" filterable clearable
          style="width:230px" @change="customerChange" :disabled='disabledcustomer'>
          <el-option v-for="(item,index) in keHuOptions" :key="index" :label="item.showName" :value="item.itemNo">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="账单备注:" prop="zhangdanRemark">
        <el-input v-model="formData.zhangdanRemark" placeholder="请输入" size="mini" maxlength="50"
          style="width:135px;vertical-align:top;"></el-input>
      </el-form-item>
      <el-form-item label="结算方式"   prop="formData" >
          <el-select size="mini"  v-model="formData.feeMode" placeholder="请选择">
              <el-option label="月结"  value="月结"></el-option>
              <!-- <el-option label="现结"  value="现结"></el-option> -->
          </el-select>
      </el-form-item>
      <hr>
      <el-form-item label="费用合计:" prop="cangchufei">
        <span style="color:red;">{{formData.cangchufei}}</span>元
      </el-form-item>
      <el-form-item label="附加:" prop="fujiafei">
        <el-input v-model="formData.fujiafei" v-number-input.float="3" @blur="fujiafeiInput" placeholder="请输入"
          size="mini" style="width:135px;vertical-align:top;"><span slot="suffix">元</span></el-input>
      </el-form-item>
      <el-form-item label="减免:" prop="koujianfei">
        <el-input v-model="formData.koujianfei" v-number-input.float="3" @blur="koujianInput" placeholder="请输入"
          size="mini" style="width:150px;vertical-align:top;"><span slot="suffix">元</span></el-input>
      </el-form-item>
      <el-form-item label="应收:" prop="heji">
        <span style="color:red;">{{formData.heji}}</span>元
      </el-form-item>
      <el-form-item label="费用备注:" prop="feiyongbeizhu">
        <el-input v-model="formData.feiyongbeizhu" placeholder="请输入" size="mini"
          style="width:210px;vertical-align:top;"></el-input>
      </el-form-item>
    </el-form>
    <hr>
    <div style="margin-bottom:10px">账单明细：
      <el-button type="primary" size="mini" @click="tianjia" v-if="btnFlg[11]" btnCode="003M320D00">新增</el-button>
      <el-button type="primary" size="mini" @click="shanchu" v-if="btnFlg[12]" btnCode="003M320E00">删除</el-button>
      <span style="margin-left:10px">总件数：<span style="color:red;">{{allNumber}}</span> 件,&nbsp;&nbsp;总吨数：<span
          style="color:red;">{{allWeight}}</span> 吨</span>
    </div>
    <div :style="{ height: '405px' }" v-if="this.titleList.length == 0" class="tablestyle">
      <span style="color:#9a9ca2">暂无数据</span>
    </div>
    <div :style="{ height: '405px' }" v-else>
      <el-table height="100%" size="mini" border center bordersize="mini" ref="tabref1" :data="tableData"
        style="width: 100%" class="elTab" :header-cell-style="{ background: '#F5F5F5', color: 'black' }"
        highlight-current-row @selection-change="selectGoods">
        <el-table-column type="selection" align="center" width="60"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" v-for="item in titleList" :key="item.titleName"
          :prop="item.titleId instanceof Array ?'':item.titleId" :label="item.titleName" align="center"
          :width="item.titleId=='customerName'||item.titleId=='cargoBarcode'||item.titleId=='payCustomerName'||item.titleId=='outstockNo'||item.titleId=='instockDate'||item.titleId=='outstockDate'||item.titleId=='contractNumber'||item.titleId=='agreementNumber'||item.titleId=='inCustomerName'?220:120">
          <template v-if="item.titleId instanceof Array ? true : false">
            <el-table-column v-for="item in item.titleId" :key="item.titleId" :prop="item.titleId"
              :label="item.titleName"></el-table-column>
          </template>
        </el-table-column>
        <!-- <el-table-column :show-overflow-tooltip="true" prop="cargoBarcode" label="捆包号" align="center" width="200"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="productTypeName" label="货物类型" align="center" width="120"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="productName" label="品名" align="center" width="120"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="specification" label="规格" align="center" width="120"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="weight" label="重量（吨）" align="center" width="200"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="feeType" label="费用类型" align="center" width="120"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="unitPrice" label="单价" align="center" width="120"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="amount" label="金额" align="center" width="120"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="stockDay" label="库存天数" align="center" width="120"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="changeNumber" label="转货次数" align="center" width="120"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="ext1" label="到货方式" align="center" width="100"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="outstockPlateNumber" label="出库车牌号" align="center" width="150"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="driverName" label="出库司机" align="center" width="120"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="outstockNo" label="出库单编号" align="center" width="200"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="outstockDate" label="出库时间" align="center" width="200"></el-table-column> -->
      </el-table>
    </div>
    <div style="width:100px;margin:5px auto">
      <el-button type="primary" size="mini" @click="queding">提交</el-button>
    </div>
    <!-- dialog -->
    <!--点击添加-->
    <add-dialog v-if="addVisible" :addVisible.sync='addVisible' :delCargoBarcodes="delCargoBarcodes"
      @gettables='getSelectedTable' :customerName="customerName"></add-dialog>
    <!--点击查看凭证-->
    <div class="addMarkBox">
      <el-dialog title="查看图片" :close-on-click-modal="false" :visible.sync="addMarkLookBox" width="60%" center>
        <!-- <div v-if="!imgFlag">
            <div>无货损图片</div>
          </div>-->
        <div class="img_box">
          <div v-for="(item, index) in imgData" :key="index">
            <img :src="item.url" alt />
            <!-- <i v-if="seen" class="el-icon-delete" @click="delImg(item)"></i> -->
            <i class="el-icon-zoom-in" @click="handChange(item.url)"></i>
          </div>
        </div>
        <el-dialog class="oneTwo" :visible.sync="dialogVisible" title="查看凭证" append-to-body width="40%" center
          :close-on-click-modal="false">
          <div class="imgDialog">
            <img :src="imageD" alt />
          </div>
        </el-dialog>
        <div style="width: 158px; margin: 15px auto"></div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import addDialog from './addDialog.vue'
import {
  JfaddOrUpdateStorageFee,
  JfgetStorageFeeList
} from '@/api/wms-stock'
import {
  getQueryCusterData // 客户
} from '@/api/platform-settlement'

import DonMessage from '@/utils/message'
import {
  getCargoDamagePicture // 查看图片
} from '@/api/wms-access'
import {
  getBtn
} from '@/utils/getButton'

export default {
  components: {
    addDialog
  },
  name: 'billManagement',
  data () {
    return {
      formData: {
        customerName: '',
        zhangdanRemark: '',
        cangchufei: 0,
        fujiafei: '',
        koujianfei: '',
        heji: 0,
        feiyongbeizhu: '',
        feeMode: '月结'
      },
      h: '200px',
      keHuOptions: [],
      tableData: [],
      addVisible: false,
      rules: {
        customerName: [{
          required: true,
          message: '请选择',
          trigger: 'change'
        }],
        zhangdanRemark: [{
          required: false,
          message: '请选择',
          trigger: 'change'
        }],
        // cangchufei: [{ required: true, message: '请选择', trigger: 'change' }],
        fujiafei: [{
          required: false,
          message: '请选择',
          trigger: 'change'
        }],
        koujianfei: [{
          required: false,
          message: '请选择',
          trigger: 'change'
        }],
        heji: [{
          required: false,
          message: '请选择',
          trigger: 'change'
        }],
        feiyongbeizhu: [{
          required: false,
          message: '请选择',
          trigger: 'change'
        }],
        feeMode: [{
          required: false,
          message: '请选择',
          trigger: 'change'
        }]
      },
      selectedTable: [],
      addMarkLookBox: false,
      imageD: '',
      dialogVisible: false,
      imgData: [],
      title: '',
      customerName: '',
      btnFlg: [],
      btnIdArr: [
        '003M320200',
        '003M320300',
        '003M320400',
        '003M320500',
        '003M320600',
        '003M320700',
        '003M320800',
        '003M320900',
        '003M320A00',
        '003M320B00',
        '003M320C00',
        '003M320D00',
        '003M320E00',
        '003M320F00',
        '003M320G00',
        '003M320H00',
        '003M320I00',
        '003M320J00',
        '003M320K00',
        '003M320L00',
        '003M320M00',
        '003M320N00',
        '003M320O00',
        '003M320P00',
        '003M320Q00',
        '003M320R00',
        '003M320S00',
        '003M320T00',
        '003M320U00',
        '003M320V00'

      ],
      titleList: [],
      allNumber: 0,
      allWeight: 0,
      disabledcustomer: false,
      delCargoBarcodes: ''
    }
  },
  methods: {
    customerChange () {
      this.tableData = []
      this.allNumber = 0
      this.allWeight = 0
      this.formData.cangchufei = 0
      this.formData.heji = 0
      this.formData.fujiafei = ''
      this.formData.zhangdanRemark = ''
      this.formData.koujianfei = ''
      this.formData.feiyongbeizhu = ''
    },
    // 查看凭证-放大
    handChange (url) {
      this.imageD = url
      this.dialogVisible = true
    },
    // 图片查看
    imgShow (row) {
      this.addMarkLookBox = true
      getCargoDamagePicture({
        cargoId: row.cargoId // 货物id
      })
        .then((res) => {
          this.imgData = []
          this.imgData = res
        })
        .catch((err) => {
          DonMessage.error(err.message)
        })
    },
    selectGoods (selection) {
      this.selectedTable = selection
    },
    fujiafeiInput () {
      this.formData.heji = (this.formData.cangchufei / 1 + this.formData.fujiafei / 1 - this.formData.koujianfei / 1)
        .toFixed(2)
    },
    koujianInput () {
      this.formData.heji = (this.formData.cangchufei / 1 + this.formData.fujiafei / 1 - this.formData.koujianfei / 1)
        .toFixed(2)
    },
    tianjia () {
      if (!this.formData.customerName) {
        this.$message({
          message: '请先选择客户',
          type: 'error'
        })
        return
      }
      this.delCargoBarcodes = this.tableData.map(item => item.cargoBarcode).join(',')
      this.addVisible = true
      this.customerName = this.formData.customerName
    },
    shanchu () {
      let cargos = Array.from(new Set(this.selectedTable.map(item => item.cargoBarcode)))
      console.log(cargos)
      for (let i = 0; i < cargos.length; i++) {
        this.tableData = this.tableData.filter(item => item.cargoBarcode != cargos[i])
      }
      // for (let i = 0; i < this.tableData.length; i++) {
      //   for (let j = 0; j < this.selectedTable.length; j++) {
      //     if (this.tableData[i].feeDetailId == this.selectedTable[j].feeDetailId) {
      //       this.tableData.splice(i, 1)
      //     }
      //   }
      // }
      this.formData.cangchufei = this.tableData.reduce((cur, pre) => {
        return cur + pre.totalFee / 1
      }, 0).toFixed(2)
      this.$set(this.formData, 'heji', (this.formData.cangchufei / 1 + this.formData.fujiafei / 1 - this.formData
        .koujianfei / 1).toFixed(2))
      // this.formData.heji = (this.formData.cangchufei / 1 + this.formData.fujiafei / 1 - t/his.formData.koujianfei / 1).toFixed(2)
      console.log(this.formData.heji)
      this.allNumber = this.tableData.length
      this.allWeight = this.tableData.reduce((pre, cur) => (pre / 1 + cur.weight / 1).toFixed(3), 0)
    },
    queding () {
      this.$refs.formData.validate(valid => {
        if (valid) {
          if (this.formData.heji < 0) {
            this.$message.error('应收费用不能小于0！')
            return
          }
          let paycustomername = this.keHuOptions.filter(item => item.itemNo == this.formData.customerName)[0]
            .showName
          const ids = this.tableData.map(item => item.feeDetailId).join(',')
          JfaddOrUpdateStorageFee({
            payCustomerNameTaxId: this.formData.customerName,
            payCustomerName: paycustomername,
            remark: this.formData.zhangdanRemark,
            totalFee: this.formData.cangchufei,
            additionalFee: this.formData.fujiafei,
            deductionFee: this.formData.koujianfei,
            receivableFee: this.formData.heji,
            feeRemark: this.formData.feiyongbeizhu,
            // storageFeeList: this.tableData,
            feeMode: this.formData.feeMode,
            feeDetailIdList: ids,
            feeMasterId: this.formData.feeMasterId ? this.formData.feeMasterId : ''
          })
            .then(res => {
              console.log(res)
              this.$message({
                message: '添加成功',
                type: 'success'
              })
              this.$router.push('/billManagement')
            })
            .catch(err => {
              this.$message({
                message: err.message,
                type: 'error'
              })
            })
        }
      })
    },
    // getTitleTable (val) {
    //   console.log(val)
    //   this.titleList = val
    // },
    getSelectedTable (val) {
      console.log(val)
      let cargoBarcodes = Array.from(new Set(val.map(item => item.cargoBarcode))).join(',')
      console.log(cargoBarcodes)
      JfgetStorageFeeList({
        paycustomerNameTaxId: this.customerName,
        cargoBarcodes: cargoBarcodes,
        feeMasterId: -1
      })
        .then(res => {
          if (val.length != 0) {
            this.titleList = res.titleList
          } else {
            return
          }
          let arr = this.tableData.concat(val)

          const ress = new Map()
          let arrNew = arr.filter((arr) => !ress.has(arr.feeDetailId) && ress.set(arr.feeDetailId, 1))
          console.log(ress)
          this.tableData = arrNew
          this.formData.cangchufei = Math.round(this.tableData.reduce((cur, pre) => {
            return cur + pre.totalFee / 1
          }, 0) * 100) / 100
          this.formData.heji = (this.formData.cangchufei / 1 + this.formData.fujiafei / 1 - this.formData
            .koujianfei / 1).toFixed(2)
          console.log(this.formData.heji)
          this.allNumber = this.tableData.length
          this.allWeight = this.tableData.reduce((pre, cur) => (pre / 1 + cur.weight / 1).toFixed(3), 0)
        })
        .catch(error => {
          this.$message({
            message: error.message,
            type: 'error'
          })
        })
    },
    // 获取所属客户数据
    getQueryCusterData () {
      getQueryCusterData().then(res => {
        this.keHuOptions = res
      }).catch(err => {
        this.$message({
          message: err.message,
          type: 'error'
        })
      })
    }
  },
  mounted () {
    this.getQueryCusterData()
    this.btnFlg = getBtn(this.btnIdArr, '/billManagement')
    console.log(this.$route)
    if (JSON.stringify(this.$route.query) !== '{}') {
      this.disabledcustomer = true
      this.title = '修改结算'
      this.formData.customerName = this.$route.query.payCustomerNameTaxId
      this.formData.zhangdanRemark = this.$route.query.remark
      this.formData.cangchufei = this.$route.query.storageFee
      this.formData.fujiafei = this.$route.query.additionalFee
      this.formData.koujianfei = this.$route.query.deductionFee
      this.formData.heji = this.$route.query.YStotalFee
      this.formData.feiyongbeizhu = this.$route.query.feeRemark
      this.formData.feeMasterId = this.$route.query.feeMasterId
      this.$set(this.formData, 'feeMode', this.$route.query.feeMode)
      JfgetStorageFeeList({
        feeMasterId: this.$route.query.feeMasterId
      })
        .then(res => {
          console.log(res)
          this.tableData = res.feeList
          this.titleList = res.titleList
          // this.total = res.total
          this.allNumber = res.feeList.length
          this.allWeight = res.feeList.reduce((pre, cur) => (pre / 1 + cur.weight / 1).toFixed(3), 0)
        })
        .catch(error => {
          this.$message({
            message: error.message,
            type: 'error'
          })
        })
    } else {
      this.title = '添加结算'
    }
  }
}

</script>

<style lang="less" scoped>
  .el-form--inline .el-form-item {
    margin: 15px;
  }

  .tablestyle {
    border-top: 1px solid #dcdfe6;
  }

  /deep/ .el-form--inline .el-form-item {
    margin: 10px;
  }

</style>
